// Deterministic, on-brand colors for hashed usernames. Shared by the chat list and the
// danmaku overlay so a given author reads as the same color in both. The hot-pink LIVE hue
// is intentionally excluded so names never read as a status.
export const NAME_HUES = [
  "#3AB7FF",
  "#5BE7C8",
  "#FFB454",
  "#7AA2FF",
  "#C792EA",
  "#56D4DD",
  "#F2C94C",
  "#8AD96B",
];

export const STREAMER_COLOR = "#39A9FF"; // azure, matches the brand primary

function hashHue(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i++) {
    h = (h * 31 + seed.charCodeAt(i)) | 0;
  }
  return NAME_HUES[Math.abs(h) % NAME_HUES.length]!;
}

/** Color for an author: streamers get the signature azure, everyone else a stable hashed hue. */
export function nameColor(seed: string, isStreamer: boolean): string {
  return isStreamer ? STREAMER_COLOR : hashHue(seed);
}
